import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import {
  acceptAssistedClockIn,
  editTimecard,
} from 'features/timesheets/TimesheetsPage/TimecardModal/slices';

import Issue from './Issue';

const AssistedClockIn = ({ issue, onChangeShift, shift, setChangesMade }) => {
  const dispatch = useDispatch();
  const handleClick = useCallback(() => {
    dispatch(editTimecard());
    setChangesMade(true);

    if (shift.get('scheduled')) {
      onChangeShift('actual_start_at', shift.get('scheduled_start_at'));
    }
  }, [dispatch, onChangeShift, setChangesMade, shift]);

  const handleDismissClick = useCallback(() => {
    dispatch(
      acceptAssistedClockIn({
        id: shift.get('id'),
        originPath: window.location.pathname,
      })
    );
  }, [dispatch, shift]);

  return (
    <Issue
      issue={issue}
      onClick={handleClick}
      onDismissClick={handleDismissClick}
    />
  );
};

export default AssistedClockIn;
